import { Grid, Typography } from '@mui/material'
import axios from 'axios'
import { useEffect, useState } from 'react'
import TabsGeneral from 'src/components/Tabs'
import useLayoutContext from 'src/hooks/useAuthLayout'
import NuevoEstudio from './estudios/index'
import Lista from './Lista'

export default function Index({ title, addEstudios, estudios, persona, boton, setEstudios, datosUsuario }) {
    const { drawerOpen } = useLayoutContext()
    const [lista, setLista] = useState([])
    // const [estudios2, setEstudios2] = useState([])
    const [datosExamenes, setDatosExamenes] = useState([])
    const [fechasHoras, setFechasHoras] = useState('')
    const [fechasHorasActual, setFechasHorasActual] = useState('')



    const getDatos = async () => {
        try {
            const res = await axios.get(`http://200.121.91.211:4001/getExamenesHospitalizacion/${drawerOpen.item.boton.persona_internacion_id}`)
            // const citas = await axios.get(`http://200.121.91.211:4001/consultaBasica/${drawerOpen.item.boton.persona_internacion_id}`)
            // setEstudios2(citas.data.estudios)
            setLista(res.data.estudiosNew.reduce((arr, item) => {
                let existe = arr.findIndex(x => x.id === item.tituloCodigo)
                if (existe < 0) {
      
                  arr.push({ id: item.tituloCodigo, titulo: item.titulo, componentes: [item], informacion: item.informacion, impresion: item.impresion, fechahora: item.fechaHora })
                } else {
                  arr[existe].componentes.push(item)
                }
                return arr
              }, []))
              setFechasHorasActual(res.data.estudiosNew.fechaHora)
              console.log(res.data.estudiosNew)
            
        } catch (e) {
            console.log(e);
        }
    }

    // const getDatosEnfermeria = async (id) => {
    //     try {
    //         const citas = await axios.get(`http://200.121.91.211:4001/historiaPacienteEnfermera/${id}`)

    //         setHistorial(citas.data.historial)
    //     } catch (e) {
    //         console.log(e);
    //     }
    // }

    // const getDatosAtencion = async (id) => {
    //     try {
    //         const citas = await axios.get(`http://200.121.91.211:4001/historiaPaciente/${id}`)
    //         setHistorial(citas.data.historial)
    //     } catch (e) {
    //         console.log(e);
    //     }
    // }


    useEffect(() => {
        console.log(drawerOpen.item.boton.persona_internacion_id)
        setDatosExamenes(drawerOpen.item.boton.persona_internacion_id)
        // console.log(19373)
    }, [drawerOpen])

    useEffect(() => {
        // console.log(estudios2)
        console.log(boton)
        console.log(datosExamenes)
        console.log(datosUsuario)
        console.log("La fecha y hora son: ", fechasHoras)
    }, [datosExamenes, datosUsuario, fechasHoras])

    // setContenido(citas.data.datos)
    // if (citas.data.datos[0].mostrarGinecologica === 'SI') {
    //   const gine = await axios.get(`http://200.121.91.211:4001/consultaBasicaGinecologia/${consultaId}`)
    //   setGinecologia(gine.data.datos)
    // }
    // setRecetas(citas.data.recetas)
    // setDiagnosticos(citas.data.diagnostico)


    useEffect(() => {
        getDatos()
    }, [])

    useEffect(() => {
        console.log(lista)
        
    }, [lista])

    const [tabs, setTabs] = useState([
        { value: '01', label: 'Historico', active: true },
        { value: '02', label: 'Registrar nuevo', active: false },
    ])

    useEffect(() => {
        console.log(addEstudios)
        console.log(estudios)
    }, [addEstudios, estudios])

    const addEstudiosModal = (array) => {
        addEstudios(array)
    }

    return (
        <>
            <Typography variant='h4'>{title}</Typography>
            <Grid
                sx={{
                    px: { xs: 0, md: 2 },
                    mt: 1
                }}
                container
                justifyContent={"center"}
                direction="row"
                alignItems="stretch"
                spacing={2}
            >
                <Grid item lg={4} sx={{ mx: 2 }}>
                    <TabsGeneral setTabs={setTabs} tabs={tabs} />
                </Grid>
                {tabs.find(x => x.active).value === '02' && <NuevoEstudio fechasHoras={fechasHoras} setFechasHoras={setFechasHoras} setEstudios={setEstudios} estudios={estudios} persona={persona} datosExamenes={datosExamenes} setTabs={setTabs} addEstudiosModal={addEstudiosModal} getDatos={getDatos} />}

                {tabs.find(x => x.active).value === '01' &&
                    <Grid item lg={12} sx={{ mx: 2 }}>
                        <Lista datosUsuario={datosUsuario} fechasHoras={fechasHorasActual} lista={lista} />
                        {/* <Box>holaaa</Box> */}
                    </Grid>}

            </Grid>
        </>
    )
}
